
import { defineComponent, PropType } from "vue";
import {
  Course,
  CourseTrack,
  Instructor,
  School,
} from "../../../../../domain/entities/entities";

const __default__ = defineComponent({
  name: "Card",
  props: {
    entityTitle: {
      type: String,
      required: true,
    },
    entityImage: {
      type: String,
      default: () =>
        require("../../../assets/static/decola_logos/iconDecolaSmall.svg"),
    },
    entity: {
      type: Object as PropType<School | Course | CourseTrack | Instructor>,
    },
    borderRadius: {
      type: String,
    },
  },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "1d2ea802": (_ctx.borderRadius)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__